import { ref, nextTick, readonly } from 'vue';

// Global print state - shared across all components
const isPrinting = ref(false);

export function usePrintState() {
  const setPrintMode = async (printing: boolean) => {
    isPrinting.value = printing;
    // Give components time to react to the state change
    await nextTick();
  };

  const triggerPrint = async () => {
    // Set print mode to expand all ReadMore components
    await setPrintMode(true);

    // Wait for ReadMore expansion and height recalculation to complete
    setTimeout(() => {
      window.print();

      // Reset print mode after printing (wait for print dialog to close)
      setTimeout(() => {
        setPrintMode(false);
      }, 300);
    }, 1000);
  };

  return {
    isPrinting: readonly(isPrinting),
    setPrintMode,
    triggerPrint,
  };
}
